module.exports = __webpack_public_path__ + "img/householdequipment1.75be0099.png";